import Relay from 'react-relay';

export default class AddHashTagMutation extends Relay.Mutation {
  getMutation() {
    return Relay.QL`mutation{addHashTag}`;
  }

  getVariables() {
    return {
      tag: this.props.tag,
      message: this.props.message,
      agentId: this.props.agentId,
    };
  }

  getFatQuery() {
    return Relay.QL`
      fragment on AddHashTagPayload {
        agent {
          hashTags
        }
      }
    `;
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        agent: this.props.agentRelayId
      }
    }];
  }
}



/** WEBPACK FOOTER **
 ** ./src/mutations/AddHashTagMutation.js
 **/